module.exports = __webpack_public_path__ + "img/zc-poster.4f279fe0.png";